import { render } from "./default-content.vue?vue&type=template&id=28d3fdb2"
import script from "./default-content.vue?vue&type=script&lang=js"
export * from "./default-content.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__